/* global fetch */
import * as constants from './constants';
import { get, del } from '../../../utils/http';
import checkStatus from '../../../utils/checkStatus';

export function updateUMProps(payload) {
  return { type: constants.UPDATE_UM_PROP, payload };
}

export const getCompanyAdmin = (companyType) => dispatch => {
  dispatch({ type: constants.GETTING_COMP_ADMIN });
  return get(`/proxy/userManagement/admin/${companyType}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => dispatch({ type: constants.GOT_COMP_ADMIN, payload: response }))
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.GETTING_COMP_ADMIN_FAILED, payload: err });
  });
};

export const getUsersByFilter = (filterBy) => dispatch => {
  dispatch({ type: constants.GETTING_USERS_BY_FILTER });
  return get(`/proxy/userManagement/${filterBy}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => dispatch({ type: constants.GOT_USERS_BY_FILTER, payload: response }))
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.GETTING_USERS_BY_FILTER_FAILED, payload: err });
  });
};

export const approveOrRejectUser = (user, action) => dispatch => {
  dispatch({ type: constants.APPROVE_REJECT_USER_STARTED });
  return fetch('/proxy/settings/approveOrRejectUser', {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ user, action }),
  })
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.APPROVE_REJECT_USER_FAILED, payload: response.error });
    return dispatch({ type: constants.APPROVE_REJECT_USER_DONE, payload: response });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.APPROVE_REJECT_USER_FAILED });
  });
};

export const addUser = payload => async dispatch => {
  try {
    dispatch({ type: constants.ADD_USER_STARTING });
    const response = await fetch('/proxy/userManagement/addUser', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const json = await response.json();
    if (json.error || response.status < 200 || response.status > 300) {
      return dispatch({ type: constants.ADD_USER_FAILED, payload: json || response });
    }
    return dispatch({ type: constants.ADDED_USER, payload: response });
  } catch (err) {
    return dispatch({ type: constants.ADD_USER_FAILED, payload: err });
  }
};

export const editUser = (payload) => dispatch => {
  dispatch({ type: constants.UPDATE_USER_STARTING });
  return fetch('/proxy/userManagement/editUser', {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.UPDATE_USER_FAILED, payload: response });
    dispatch({ type: constants.UPDATED_USER, payload: response });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.UPDATE_USER_FAILED, payload: err });
  });
};

export const deleteUser = (userId) => (dispatch) => {
  dispatch({ type: constants.DELETE_USER_STARTING });
  return del(`/proxy/userManagement/editUser/${userId}`)
  .then(checkStatus)
  .then(response => {
    if (response.error) return dispatch({ type: constants.DELETE_USER_FAILED });
    dispatch({ type: constants.DELETED_USER, payload: userId });
  })
  .catch(err => {
    console.log(err);
    dispatch({ type: constants.DELETE_USER_FAILED, payload: err });
  });
};



// WEBPACK FOOTER //
// ./src/app/stores/settings/userManagement/actions.js